module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normal2"
  }, [_vm._v("Gypsy: Brownish to white European moth which flits from place to place causing much damage. A serious pest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Member of a scattered, nomadic people with a mind-set of its own.")]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1"
  }, [_c('span', [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('i', [_vm._v("Gypsy")]), _vm._v(" is a work of fiction in which actual places and times are used but altered as appropriate. Occasionally the name of a real person appears for historical authenticity, though all are deceased and the story makes of them what it demands. I do not condone what happened during these times, I abhor it. But during the Occupation of France the everyday crimes of murder and arson continued to be committed, and I merely ask, by whom and how were they solved?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ddca336","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/authour.vue
// module id = 75
// module chunks = 0